import { LoginShowcase } from './components/LoginShowcase';
import { LoginCard } from './components/LoginCard';

export const LoginPage = () => {
  return (
    <div className="flex w-full min-h-screen overflow-hidden bg-white font-sans">
      {/* Left Side: Showcase (65%) */}
      <div className="hidden lg:block lg:w-[65%] h-screen sticky top-0">
        <LoginShowcase />
      </div>

      {/* Right Side: Login Form (35% on large, 100% on mobile) */}
      <div className="w-full lg:w-[35%] min-h-screen flex items-center justify-center relative bg-[#F9FAFB] lg:bg-white">
        {/* Subtle background pattern for desktop to enhance glassmorphism focus */}
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none hidden lg:block"
             style={{ backgroundImage: `radial-gradient(#2C9944 1px, transparent 1px)`, backgroundSize: '24px 24px' }} 
        />
        <LoginCard />
      </div>
    </div>
  );
};

